import { FieldTypeDisplayInfo } from '@monorepo/shared/componentsV2/fields/FieldTypeSelector';
import AddIcon from '@svg/add.svg';
import CalendarOutlineIcon from '@svg/calendar-outline.svg';
import CameraIcon from '@svg/camera.svg';
import CircleCheckIcon from '@svg/circle-check.svg';
import ClockIcon from '@svg/clock.svg';
import DocumentIcon from '@svg/document.svg';
import HashIcon from '@svg/hash.svg';
import InfoIcon from '@svg/info.svg';
import LocationIcon from '@svg/location.svg';
import MapIcon from '@svg/m-map-dashboard.svg';
import MultiLocationIcon from '@svg/multi-location.svg';
import MultiSelectFreeIcon from '@svg/multi-select-free.svg';
import MultiSelectIcon from '@svg/multi-select.svg';
import MultiUserIcon from '@svg/multi-user.svg';
import ParagraphIcon from '@svg/paragraph.svg';
import PhoneIcon from '@svg/phone.svg';
import RecurringIcon from '@svg/recurring.svg';
import SignatureIcon from '@svg/signature.svg';
import TextIcon from '@svg/text.svg';
import ToggleIcon from '@svg/toggle.svg';
import UserIcon from '@svg/user.svg';
import WeatherIcon from '@svg/weather.svg';
import WrenchIcon from '@svg/wrench.svg';
import { FormTemplateFieldTypes } from 'mapistry-shared';
import React from 'react';

export const getFieldTypeDisplay = (
  fieldType: FormTemplateFieldTypes,
): FieldTypeDisplayInfo => {
  switch (fieldType) {
    case FormTemplateFieldTypes.BOOLEAN:
      return {
        icon: <ToggleIcon />,
        label: 'Yes / No',
      };
    case FormTemplateFieldTypes.DATE:
      return {
        icon: <CalendarOutlineIcon />,
        label: 'Date',
      };
    case FormTemplateFieldTypes.DOCUMENT_UPLOADER:
      return {
        icon: <DocumentIcon />,
        label: 'Document uploader',
      };
    case FormTemplateFieldTypes.EMISSION_OBSERVATION:
      return {
        icon: <RecurringIcon />,
        label: 'Emission observation',
      };
    case FormTemplateFieldTypes.EXPLANATION_AREA:
      return {
        icon: <InfoIcon />,
        label: 'Explanation area',
      };
    case FormTemplateFieldTypes.MAP_AREA:
      return {
        icon: <MapIcon />,
        label: 'Map area',
      };
    case FormTemplateFieldTypes.MULTI_LOCATION:
      return {
        icon: <MultiLocationIcon />,
        label: 'Multi-location',
        groupLabel: 'Location',
      };
    case FormTemplateFieldTypes.MULTI_SELECT:
      return {
        icon: <MultiSelectIcon />,
        label: 'Multi-select',
      };
    case FormTemplateFieldTypes.MULTI_SELECT_WITH_FREE_FORM:
      return {
        icon: <MultiSelectFreeIcon />,
        label: 'Multi-select with free form',
        subLabel: 'with free form',
      };
    case FormTemplateFieldTypes.MULTI_USER:
      return {
        icon: <MultiUserIcon />,
        label: 'Multi-user',
      };
    case FormTemplateFieldTypes.NUMBER:
      return {
        icon: <HashIcon />,
        label: 'Number',
      };
    case FormTemplateFieldTypes.PHONE_NUMBER:
      return {
        icon: <PhoneIcon />,
        label: 'Phone number',
      };
    case FormTemplateFieldTypes.PHOTO_CAROUSEL:
      return {
        icon: <CameraIcon />,
        label: 'Photo uploader',
      };
    case FormTemplateFieldTypes.SIGNATURE:
      return {
        icon: <SignatureIcon />,
        label: 'Signature',
      };
    case FormTemplateFieldTypes.SINGLE_LOCATION:
      return {
        icon: <LocationIcon />,
        label: 'Single location',
        groupLabel: 'Location',
      };
    case FormTemplateFieldTypes.SINGLE_SELECT:
      return {
        icon: <CircleCheckIcon />,
        label: 'Single select',
      };
    case FormTemplateFieldTypes.SINGLE_SELECT_WITH_FREE_FORM:
      return {
        icon: <AddIcon />,
        label: 'Single select with free form',
        subLabel: 'with free form',
      };
    case FormTemplateFieldTypes.TASKS:
      return {
        icon: <WrenchIcon />,
        label: 'Tasks',
      };
    case FormTemplateFieldTypes.TEXT:
      return {
        icon: <TextIcon />,
        label: 'Short text',
      };
    case FormTemplateFieldTypes.TEXT_AREA:
      return {
        icon: <ParagraphIcon />,
        label: 'Long text',
      };
    case FormTemplateFieldTypes.TIME:
      return {
        icon: <ClockIcon />,
        label: 'Time',
      };
    case FormTemplateFieldTypes.USER:
      return {
        icon: <UserIcon />, // we now have 2 very similar icons - PersonIcon and UserIcon
        label: 'User',
      };
    case FormTemplateFieldTypes.WEATHER:
      return {
        icon: <WeatherIcon />,
        label: 'Weather',
      };
    default: {
      const exhaustive: never = fieldType;
      throw new Error(`Invalid field type - ${exhaustive}`);
    }
  }
};

export const getFieldTypeInline = (fieldType: FormTemplateFieldTypes) => {
  const { label } = getFieldTypeDisplay(fieldType);

  // "yes / no" is a bit more awkward lowercase than the rest
  if (fieldType === FormTemplateFieldTypes.BOOLEAN) {
    return label;
  }
  return label.toLowerCase();
};
